<template>
   <div class="description">
        <div class="description-title">
            <div class="description-title-text">
                <template v-if="title">{{title}}</template>
                <slot v-else name="title"/>
            </div>
            <div class="description-title-extra">
                <!-- TODO 展开收起 -->
                <slot name="extra"/>
            </div>
        </div>
        <div class="description-body">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VDescription',
    props: {
        title: String
    }
}
</script>
<style lang="less" scoped>
.description {
    &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        padding: 0 30px;
        background: #f3f3f3;
        &-text {
            font-size: 18px;
            color: #333;
        }
    }
    &-body {
        padding: 20px 30px 30px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/descirption/index.vue